import { render, staticRenderFns } from "./table-delegate.vue?vue&type=template&id=6aa817cc&scoped=true&"
import script from "./table-delegate.vue?vue&type=script&lang=js&"
export * from "./table-delegate.vue?vue&type=script&lang=js&"
import style0 from "./table-delegate.vue?vue&type=style&index=0&id=6aa817cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa817cc",
  null
  
)

export default component.exports